/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetMessagesUnread } from '../models/GetMessagesUnread';
import type { message } from '../models/message';
import type { messages } from '../models/messages';
import type { NewMessage } from '../models/NewMessage';
import type { NewUserMessage } from '../models/NewUserMessage';
import type { UserMessagesUnread } from '../models/UserMessagesUnread';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessageService {
    /**
     * GetMessages
     * @returns messages Сообщения
     * @throws ApiError
     */
    public static getMessages(): CancelablePromise<messages> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/messages',
        });
    }
    /**
     * GetMessagesUnread
     * @returns GetMessagesUnread MessagesUnreadGot
     * @throws ApiError
     */
    public static getMessagesUnread(): CancelablePromise<GetMessagesUnread> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/messages/unread',
        });
    }
    /**
     * AddMessage
     * @returns message Сообщения
     * @throws ApiError
     */
    public static addMessage({
        requestBody,
    }: {
        /**
         * Новое сообщение
         */
        requestBody: NewMessage,
    }): CancelablePromise<message> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * GetUserMessages
     * @returns messages Сообщения
     * @throws ApiError
     */
    public static getUserMessages({
        id,
    }: {
        /**
         * Идентификатор пользователя
         */
        id: number,
    }): CancelablePromise<messages> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-messages',
            query: {
                'id': id,
            },
        });
    }
    /**
     * GetUserMessagesUnread
     * @returns UserMessagesUnread UserMessagesUnreadGot
     * @throws ApiError
     */
    public static getUserMessagesUnread(): CancelablePromise<UserMessagesUnread> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-messages/unread',
        });
    }
    /**
     * AddUserMessage
     * @returns message Сообщения
     * @throws ApiError
     */
    public static addUserMessage({
        requestBody,
    }: {
        /**
         * Новое сообщение
         */
        requestBody: NewUserMessage,
    }): CancelablePromise<message> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user-message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
